import { createContext } from 'react';
import { FormControlContextType } from './types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FormControlContext = createContext<FormControlContextType<any>>({
  setValue: () => {},
} as unknown as FormControlContextType);
